import { useForm } from "hooks/useForm";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateNoteAcc } from "redux/actions/liquidations/liquidationsAction";
import { SubmitBtns } from "components/CustomButtons/SubmitBtns";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal";
import { blue } from "@mui/material/colors";
import { handleFetchLessDataOneStation } from "./actions/fetchData";
import { Grid, Typography } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";

export const UpdateNoteAccount = ({ note, onClose }) => {
  const BLUE = blue[800];
  const ERP = "ERP";
  const dispatch = useDispatch();

  const {
    liquidations: { station },
    search: { isLoadingComp },
    companies: { stations },
    routesStatus: {
      settlement: { unit },
    },
  } = useSelector(({ liquidations, search, companies, routesStatus }) => ({
    liquidations,
    search,
    companies,
    routesStatus,
  }));

  const [[_, loading], fetchCustomers] = useFetchLocal(
    handleFetchLessDataOneStation,
  );

  const { values, setValues, errors, validate, onChange } = useForm(
    {
      customersOpt: [],
      searchCustomer: "",
      idAccount: null,
    },
    {
      idAccount: { required: true },
    },
  );

  const { customersOpt, idAccount, searchCustomer } = values;
  const [error, setError] = useState(false);
  const [filterERP, setFilterERP] = useState([]);
  const [openList, setOpenList] = useState(false);

  const handleFetchCustomers = useCallback(() => {
    const customerTrim = searchCustomer.trim();
    if (customerTrim.length >= 3) {
      setError(false);
      fetchCustomers(station, customerTrim, stations, setValues);
    } else {
      setError(true);
    }
  }, [searchCustomer]);

  const handleSubmit = useCallback(() => {
    validate([], () => {
      const form = {
        noteId: note.id,
        idAccount: idAccount.idAccount,
        accountName: idAccount.alias,
        accountCode: idAccount.accountCode,
      };
      dispatch(updateNoteAcc(form, onClose));
    });
  }, [idAccount?.idAccount]);

  useEffect(() => {
    const optFilterERP = customersOpt.filter(
      (customer) =>
        customer.accountCode.includes(ERP) &&
        customer.accountType === unit.type,
    );
    setFilterERP(optFilterERP);
    if (optFilterERP.length === 1) {
      setValues({ idAccount: optFilterERP[0], searchCustomer: optFilterERP[0].label || optFilterERP[0].alias || "" });
    } else if (optFilterERP.length > 1) {
      setOpenList(true);
    }
  }, [customersOpt]);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">Detalles de la Nota</Typography>
        <Typography variant="body1">
          Folio: <span style={{ color: BLUE }}>{note.folio}</span>
        </Typography>
        <Typography variant="body1">
          Código: <span style={{ color: BLUE }}>{note.accountCode}</span>
        </Typography>
        <Typography variant="body1">
          Nombre: <span style={{ color: BLUE }}>{note.accountName}</span>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <AutocompleteComponent
          label={"Cliente"}
          options={filterERP}
          name={"idAccount"}
          value={idAccount}
          inputValue={searchCustomer}
          open={openList}
          onOpen={() => setOpenList(true)}
          onClose={() => setOpenList(false)}
          onInputChange={(_, newInputValue, reason) => {
            if (reason === "clear") {
              setValues({ searchCustomer: "", idAccount: null });
              return;
            }
            if (reason === "reset" && !newInputValue) return;
            setValues({ searchCustomer: newInputValue });
          }}
          handleValues={setValues}
          disabled={loading || isLoadingComp?.updateNoteAcc}
          textFieldProps={{
            error:
              idAccount?.id || idAccount?.idAccount
                ? false
                : errors.idAccount || error || !idAccount,
            helperText: errors.idAccount || "Ingresa al menos 4 caracteres",
          }}
          onAction={
            <RegularButton
              type="submit"
              color="transparent"
              size="sm"
              onClick={handleFetchCustomers}
              loading={loading}
            >
              <span style={{ color: BLUE }}>Buscar</span>
            </RegularButton>
          }
          optionsOpen
        />
      </Grid>
      <SubmitBtns
        onClose={onClose}
        onSubmit={handleSubmit}
        loading={isLoadingComp?.updateNoteAcc || loading}
      />
    </>
  );
};
